const WrapperStatus = ({
  label,
  icon,
  background = "#007bff",
  color = "#ffffff",
  onClick = () => undefined,
  disabled = false,
  style = {},
  className = "",
}) => {
  const getStatusStyles = () => {
    const baseStyles = {
      display: "flex",
      padding: "4px 12px",
      alignItems: "center",
      gap: 8,
      borderRadius: "21px",
      width: "fit-content",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.6 : 1,
      transition: "all 0.2s ease",
      ...style,
    };

    if (disabled) {
      return {
        ...baseStyles,
        background: "#E5E5E5",
        color: "#ADADAD",
      };
    }

    return {
      ...baseStyles,
      background,
      color,
    };
  };

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick(e);
  };

  return (
    <div
      style={getStatusStyles()}
      onClick={handleClick}
      className={className}
      role="button"
      tabIndex={disabled ? -1 : 0}
    >
      {icon && <i className={icon}></i>}
      <p style={{ margin: 0, fontSize: 12 }}>{label}</p>
    </div>
  );
};

export default WrapperStatus;
